export enum StatusMessageType{

  CUSTOMER_INTERACTION_OPENED= "CUSTOMER_INTERACTION_OPENED",
  CUSTOMER_INTERACTION_ADMIN_RESPONSE = "CUSTOMER_INTERACTION_ADMIN_RESPONSE",
  CUSTOMER_INTERACTION_USER_RESPONSE = "CUSTOMER_INTERACTION_USER_RESPONSE",
  CUSTOMER_INTERACTION_CLOSED = "CUSTOMER_INTERACTION_CLOSED",
  INTERN_STATUS_COMMENT = "INTERN_STATUS_COMMENT",
  EXTERN_STATUS_COMMENT = "EXTERN_STATUS_COMMENT",
  DOCUMENT_COMPLETED = "DOCUMENT_COMPLETED",
  AUTOMATIC_REMINDER = "AUTOMATIC_REMINDER",
  PHONE_TICKET_NOT_REACHED = "PHONE_TICKET_NOT_REACHED",
  PHONE_TICKET_REACHED = "PHONE_TICKET_REACHED",
  PHONE_TICKET_MAIL_REMINDER = "PHONE_TICKET_MAIL_REMINDER",
  PHONE_TICKET_CREATED = "PHONE_TICKET_CREATED",
  DOCUMENT_CANCELED = "DOCUMENT_CANCELED",
  DOCUMENT_REQUESTED = "DOCUMENT_REQUESTED",
  ORDER_CREATED = "ORDER_CREATED"

}
